import React from "react";

export default function SimpleFinderAlert (props) {
  const {locAlert, update_loc_alert} = props
  if (locAlert.type) {
    setTimeout(()=>{

      update_loc_alert(
        {
          "type": "",
          "text": "All is OK",
          "time": 3000
        }
      )
    }, locAlert.time)
  }
  if (locAlert.type) {
    return (
      <div className={`alert ${locAlert.type}`} role="alert">
        {locAlert.text}
      </div>
  )
  } else return <></>

}

/* 

        locAlert={this.props.location.locAlert}
        update_loc_alert={this.props.update_loc_alert}
*/